/* tslint:disable */
/* eslint-disable */
import { HttpClient, HttpContext } from '@angular/common/http';
import { Injectable } from '@angular/core';
import { Observable } from 'rxjs';
import { map } from 'rxjs/operators';

import { BaseService } from '../base-service';
import { ApiConfiguration } from '../api-configuration';
import { StrictHttpResponse } from '../strict-http-response';

import { GetBehaviorOptions } from '../fn/parent/get-behavior-options';
import { GetBehaviorOptions$Params } from '../fn/parent/get-behavior-options';
import { GetBehaviors } from '../fn/parent/get-behaviors';
import { GetBehaviors$Params } from '../fn/parent/get-behaviors';
import { GetPatients } from '../fn/parent/get-patients';
import { GetPatients$Params } from '../fn/parent/get-patients';
import { GetPlaylists } from '../fn/parent/get-playlists';
import { GetPlaylists$Params } from '../fn/parent/get-playlists';
import { GetPrograms } from '../fn/parent/get-programs';
import { GetPrograms$Params } from '../fn/parent/get-programs';
import { GetPromptSchedules } from '../fn/parent/get-prompt-schedules';
import { GetPromptSchedules$Params } from '../fn/parent/get-prompt-schedules';
import { GetSessions } from '../fn/parent/get-sessions';
import { GetSessions$Params } from '../fn/parent/get-sessions';
import { GetTargets } from '../fn/parent/get-targets';
import { GetTargets$Params } from '../fn/parent/get-targets';
import { ParentBehaviorOptionsModel } from '../models/parent-behavior-options-model';
import { PatientBehaviorModel } from '../models/patient-behavior-model';
import { PatientModel } from '../models/patient-model';
import { PatientPlaylistModel } from '../models/patient-playlist-model';
import { PatientProgramModel } from '../models/patient-program-model';
import { PatientSessionModel } from '../models/patient-session-model';
import { PatientTargetModel } from '../models/patient-target-model';
import { PromptScheduleModel } from '../models/prompt-schedule-model';
import { SaveSession } from '../fn/parent/save-session';
import { SaveSession$Params } from '../fn/parent/save-session';
import { SendLogs } from '../fn/parent/send-logs';
import { SendLogs$Params } from '../fn/parent/send-logs';
import { StartSession } from '../fn/parent/start-session';
import { StartSession$Params } from '../fn/parent/start-session';

@Injectable({ providedIn: 'root' })
export class ParentApiService extends BaseService {
  constructor(config: ApiConfiguration, http: HttpClient) {
    super(config, http);
  }

  /** Path part for operation `apiParentSendLogsPost()` */
  static readonly ApiParentSendLogsPostPath = '/api/Parent/SendLogs';

  /**
   * This method provides access to the full `HttpResponse`, allowing access to response headers.
   * To access only the response body, use `SendLogs()` instead.
   *
   * This method sends `application/*+json` and handles request body of type `application/*+json`.
   */
  SendLogs$Response(params?: SendLogs$Params, context?: HttpContext): Observable<StrictHttpResponse<void>> {
    return SendLogs(this.http, this.rootUrl, params, context);
  }

  /**
   * This method provides access only to the response body.
   * To access the full response (for headers, for example), `SendLogs$Response()` instead.
   *
   * This method sends `application/*+json` and handles request body of type `application/*+json`.
   */
  SendLogs(params?: SendLogs$Params, context?: HttpContext): Observable<void> {
    return this.SendLogs$Response(params, context).pipe(
      map((r: StrictHttpResponse<void>): void => r.body)
    );
  }

  /** Path part for operation `apiParentGetPatientsGet()` */
  static readonly ApiParentGetPatientsGetPath = '/api/Parent/GetPatients';

  /**
   * This method provides access to the full `HttpResponse`, allowing access to response headers.
   * To access only the response body, use `GetPatients()` instead.
   *
   * This method doesn't expect any request body.
   */
  GetPatients$Response(params?: GetPatients$Params, context?: HttpContext): Observable<StrictHttpResponse<Array<PatientModel>>> {
    return GetPatients(this.http, this.rootUrl, params, context);
  }

  /**
   * This method provides access only to the response body.
   * To access the full response (for headers, for example), `GetPatients$Response()` instead.
   *
   * This method doesn't expect any request body.
   */
  GetPatients(params?: GetPatients$Params, context?: HttpContext): Observable<Array<PatientModel>> {
    return this.GetPatients$Response(params, context).pipe(
      map((r: StrictHttpResponse<Array<PatientModel>>): Array<PatientModel> => r.body)
    );
  }

  /** Path part for operation `apiParentGetTargetsGet()` */
  static readonly ApiParentGetTargetsGetPath = '/api/Parent/GetTargets';

  /**
   * This method provides access to the full `HttpResponse`, allowing access to response headers.
   * To access only the response body, use `GetTargets()` instead.
   *
   * This method doesn't expect any request body.
   */
  GetTargets$Response(params?: GetTargets$Params, context?: HttpContext): Observable<StrictHttpResponse<Array<PatientTargetModel>>> {
    return GetTargets(this.http, this.rootUrl, params, context);
  }

  /**
   * This method provides access only to the response body.
   * To access the full response (for headers, for example), `GetTargets$Response()` instead.
   *
   * This method doesn't expect any request body.
   */
  GetTargets(params?: GetTargets$Params, context?: HttpContext): Observable<Array<PatientTargetModel>> {
    return this.GetTargets$Response(params, context).pipe(
      map((r: StrictHttpResponse<Array<PatientTargetModel>>): Array<PatientTargetModel> => r.body)
    );
  }

  /** Path part for operation `apiParentGetProgramsGet()` */
  static readonly ApiParentGetProgramsGetPath = '/api/Parent/GetPrograms';

  /**
   * This method provides access to the full `HttpResponse`, allowing access to response headers.
   * To access only the response body, use `GetPrograms()` instead.
   *
   * This method doesn't expect any request body.
   */
  GetPrograms$Response(params?: GetPrograms$Params, context?: HttpContext): Observable<StrictHttpResponse<Array<PatientProgramModel>>> {
    return GetPrograms(this.http, this.rootUrl, params, context);
  }

  /**
   * This method provides access only to the response body.
   * To access the full response (for headers, for example), `GetPrograms$Response()` instead.
   *
   * This method doesn't expect any request body.
   */
  GetPrograms(params?: GetPrograms$Params, context?: HttpContext): Observable<Array<PatientProgramModel>> {
    return this.GetPrograms$Response(params, context).pipe(
      map((r: StrictHttpResponse<Array<PatientProgramModel>>): Array<PatientProgramModel> => r.body)
    );
  }

  /** Path part for operation `apiParentGetSessionsGet()` */
  static readonly ApiParentGetSessionsGetPath = '/api/Parent/GetSessions';

  /**
   * This method provides access to the full `HttpResponse`, allowing access to response headers.
   * To access only the response body, use `GetSessions()` instead.
   *
   * This method doesn't expect any request body.
   */
  GetSessions$Response(params?: GetSessions$Params, context?: HttpContext): Observable<StrictHttpResponse<Array<PatientSessionModel>>> {
    return GetSessions(this.http, this.rootUrl, params, context);
  }

  /**
   * This method provides access only to the response body.
   * To access the full response (for headers, for example), `GetSessions$Response()` instead.
   *
   * This method doesn't expect any request body.
   */
  GetSessions(params?: GetSessions$Params, context?: HttpContext): Observable<Array<PatientSessionModel>> {
    return this.GetSessions$Response(params, context).pipe(
      map((r: StrictHttpResponse<Array<PatientSessionModel>>): Array<PatientSessionModel> => r.body)
    );
  }

  /** Path part for operation `apiParentGetBehaviorsGet()` */
  static readonly ApiParentGetBehaviorsGetPath = '/api/Parent/GetBehaviors';

  /**
   * This method provides access to the full `HttpResponse`, allowing access to response headers.
   * To access only the response body, use `GetBehaviors()` instead.
   *
   * This method doesn't expect any request body.
   */
  GetBehaviors$Response(params?: GetBehaviors$Params, context?: HttpContext): Observable<StrictHttpResponse<Array<PatientBehaviorModel>>> {
    return GetBehaviors(this.http, this.rootUrl, params, context);
  }

  /**
   * This method provides access only to the response body.
   * To access the full response (for headers, for example), `GetBehaviors$Response()` instead.
   *
   * This method doesn't expect any request body.
   */
  GetBehaviors(params?: GetBehaviors$Params, context?: HttpContext): Observable<Array<PatientBehaviorModel>> {
    return this.GetBehaviors$Response(params, context).pipe(
      map((r: StrictHttpResponse<Array<PatientBehaviorModel>>): Array<PatientBehaviorModel> => r.body)
    );
  }

  /** Path part for operation `apiParentGetPlaylistsGet()` */
  static readonly ApiParentGetPlaylistsGetPath = '/api/Parent/GetPlaylists';

  /**
   * This method provides access to the full `HttpResponse`, allowing access to response headers.
   * To access only the response body, use `GetPlaylists()` instead.
   *
   * This method doesn't expect any request body.
   */
  GetPlaylists$Response(params?: GetPlaylists$Params, context?: HttpContext): Observable<StrictHttpResponse<Array<PatientPlaylistModel>>> {
    return GetPlaylists(this.http, this.rootUrl, params, context);
  }

  /**
   * This method provides access only to the response body.
   * To access the full response (for headers, for example), `GetPlaylists$Response()` instead.
   *
   * This method doesn't expect any request body.
   */
  GetPlaylists(params?: GetPlaylists$Params, context?: HttpContext): Observable<Array<PatientPlaylistModel>> {
    return this.GetPlaylists$Response(params, context).pipe(
      map((r: StrictHttpResponse<Array<PatientPlaylistModel>>): Array<PatientPlaylistModel> => r.body)
    );
  }

  /** Path part for operation `apiParentGetBehaviorOptionsGet()` */
  static readonly ApiParentGetBehaviorOptionsGetPath = '/api/Parent/GetBehaviorOptions';

  /**
   * This method provides access to the full `HttpResponse`, allowing access to response headers.
   * To access only the response body, use `GetBehaviorOptions()` instead.
   *
   * This method doesn't expect any request body.
   */
  GetBehaviorOptions$Response(params?: GetBehaviorOptions$Params, context?: HttpContext): Observable<StrictHttpResponse<ParentBehaviorOptionsModel>> {
    return GetBehaviorOptions(this.http, this.rootUrl, params, context);
  }

  /**
   * This method provides access only to the response body.
   * To access the full response (for headers, for example), `GetBehaviorOptions$Response()` instead.
   *
   * This method doesn't expect any request body.
   */
  GetBehaviorOptions(params?: GetBehaviorOptions$Params, context?: HttpContext): Observable<ParentBehaviorOptionsModel> {
    return this.GetBehaviorOptions$Response(params, context).pipe(
      map((r: StrictHttpResponse<ParentBehaviorOptionsModel>): ParentBehaviorOptionsModel => r.body)
    );
  }

  /** Path part for operation `apiParentGetPromptSchedulesGet()` */
  static readonly ApiParentGetPromptSchedulesGetPath = '/api/Parent/GetPromptSchedules';

  /**
   * This method provides access to the full `HttpResponse`, allowing access to response headers.
   * To access only the response body, use `GetPromptSchedules()` instead.
   *
   * This method doesn't expect any request body.
   */
  GetPromptSchedules$Response(params?: GetPromptSchedules$Params, context?: HttpContext): Observable<StrictHttpResponse<Array<PromptScheduleModel>>> {
    return GetPromptSchedules(this.http, this.rootUrl, params, context);
  }

  /**
   * This method provides access only to the response body.
   * To access the full response (for headers, for example), `GetPromptSchedules$Response()` instead.
   *
   * This method doesn't expect any request body.
   */
  GetPromptSchedules(params?: GetPromptSchedules$Params, context?: HttpContext): Observable<Array<PromptScheduleModel>> {
    return this.GetPromptSchedules$Response(params, context).pipe(
      map((r: StrictHttpResponse<Array<PromptScheduleModel>>): Array<PromptScheduleModel> => r.body)
    );
  }

  /** Path part for operation `apiParentStartSessionPost()` */
  static readonly ApiParentStartSessionPostPath = '/api/Parent/StartSession';

  /**
   * This method provides access to the full `HttpResponse`, allowing access to response headers.
   * To access only the response body, use `StartSession()` instead.
   *
   * This method doesn't expect any request body.
   */
  StartSession$Response(params?: StartSession$Params, context?: HttpContext): Observable<StrictHttpResponse<PatientSessionModel>> {
    return StartSession(this.http, this.rootUrl, params, context);
  }

  /**
   * This method provides access only to the response body.
   * To access the full response (for headers, for example), `StartSession$Response()` instead.
   *
   * This method doesn't expect any request body.
   */
  StartSession(params?: StartSession$Params, context?: HttpContext): Observable<PatientSessionModel> {
    return this.StartSession$Response(params, context).pipe(
      map((r: StrictHttpResponse<PatientSessionModel>): PatientSessionModel => r.body)
    );
  }

  /** Path part for operation `apiParentSaveSessionPost()` */
  static readonly ApiParentSaveSessionPostPath = '/api/Parent/SaveSession';

  /**
   * Saves the whole parent session kept on the device: every trial, and closes it once FinishedDate is set.
   * Trials without an ID are matched by target and RecordedDate, so a resent session does not duplicate them.
   *
   *
   *
   * This method provides access to the full `HttpResponse`, allowing access to response headers.
   * To access only the response body, use `SaveSession()` instead.
   *
   * This method sends `application/*+json` and handles request body of type `application/*+json`.
   */
  SaveSession$Response(params?: SaveSession$Params, context?: HttpContext): Observable<StrictHttpResponse<PatientSessionModel>> {
    return SaveSession(this.http, this.rootUrl, params, context);
  }

  /**
   * Saves the whole parent session kept on the device: every trial, and closes it once FinishedDate is set.
   * Trials without an ID are matched by target and RecordedDate, so a resent session does not duplicate them.
   *
   *
   *
   * This method provides access only to the response body.
   * To access the full response (for headers, for example), `SaveSession$Response()` instead.
   *
   * This method sends `application/*+json` and handles request body of type `application/*+json`.
   */
  SaveSession(params?: SaveSession$Params, context?: HttpContext): Observable<PatientSessionModel> {
    return this.SaveSession$Response(params, context).pipe(
      map((r: StrictHttpResponse<PatientSessionModel>): PatientSessionModel => r.body)
    );
  }

}
